import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import filterTypes from "data/filter-types";
import findFilterValue from "helpers/find-filter-value";
import { getFilters, getStatuses } from "actions/promo-codes/actions";
import searchOperationGenerator from "helpers/search-operation-generator";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";

class Filters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      reRender: false,
      filters: {}
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);

    this.props.getFilters();
    this.props.getStatuses();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.totalCount !== this.props.totalCount) {
      return true;
    } else if (nextState.isOpen !== this.state.isOpen) {
      return true;
    } else if (nextState.reRender !== this.state.reRender) {
      return true;
    } else if (!_.isEqual(nextState.filters, this.state.filters)) {
      return true;
    } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
      return true;
    }
    return false;
  }

  handleSearch = () => {
    const { filters } = this.state;
    const filtersToArray = [];
    Object.keys(filters)
      .forEach(name => {
        if (Object.keys(filters[name]).length) {
          filtersToArray.push(filters[name]);
        }
      });
    this.props.handleSearch(filtersToArray);
  };

  handleReset = () => {
    this.setState({
      filters: {},
      reRender: true
    }, () => {
      this.setState({
        reRender: false
      });
      this.props.handleReset();
    });
  };

  handleChangeFilter = (name, valueObject) => {
    const { filters } = this.state;
    filters[name] = valueObject;
    this.setState({
      filters
    });
  };

  render() {
    const {
      activeFilters,
      totalCount,
      filters,
      statuses,
    } = this.props;
    const {
      isOpen,
      // filters,
      reRender,
    } = this.state;

    if (reRender) {
      return null;
    }

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title="Promo Codes"
          totalCount={totalCount}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
        />
        <Card.Body className="p-0">
          <Collapse in={isOpen} className="p-2" timeout={0}>
            <div className="row">
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="owner"
                  placeholder="Owner"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.owner, [filterTypes.EQUALS.value])}
                  value={findFilterValue("owner", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="code"
                  placeholder="Code"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.code, [filterTypes.EQUALS.value])}
                  value={findFilterValue("code", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="status"
                  placeholder="Status"
                  filterType="select_multiple"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.status, [filterTypes.IN.value])}
                  filterTypeOptions={statuses.map(value => ({
                    label: value,
                    value
                  }))}
                  value={findFilterValue("status", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2" />
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="createdAt"
                  placeholder="Created At"
                  filterType="date"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(null, [filterTypes.MORE.value, filterTypes.LESS.value])}
                  value={findFilterValue("createdAt", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="activatedAt"
                  placeholder="Activated At"
                  filterType="date"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(null, [filterTypes.MORE.value, filterTypes.LESS.value])}
                  value={findFilterValue("activatedAt", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="usedAt"
                  placeholder="Used At"
                  filterType="date"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(null, [filterTypes.MORE.value, filterTypes.LESS.value])}
                  value={findFilterValue("usedAt", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <div
                  className="d-flex justify-content-between justify-content-md-end">
                  <button
                    className="btn btn-warning btn-sm ml-2"
                    onClick={this.handleReset}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-success btn-sm ml-2"
                    onClick={this.handleSearch}
                  >
                    Load
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    );
  }
}

Filters.defaultProps = {
  activeFilters: []
};

Filters.propTypes = {
  activeFilters: PropTypes.array.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  filters: state.promoCodes.filters,
  statuses: state.promoCodes.statuses,
});

const mapStateToDispatch = dispatch => ({
  getFilters: bindActionCreators(getFilters, dispatch),
  getStatuses: bindActionCreators(getStatuses, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Filters);



// WEBPACK FOOTER //
// ./src/views/pages/promo-codes/filters.js